import { useTranslation } from 'react-i18next';
import { CellLayout } from 'src/common/components/ConfigurableTable/Components/Cells/CellLayout';
import { StatusBadge } from 'src/common/components/StatusBadge/StatusBadge';

export const ESimProfileEnabledCell = ({ value }: { value: boolean }) => {
  const { t } = useTranslation();
  return (
    <CellLayout>
      {value ? (
        <StatusBadge
          status="success"
          type="filled"
          label={t('products.eSim.inventory.cells.eSimProfile.enabled')}
          hideIcon
        />
      ) : (
        <StatusBadge
          status="inactive"
          type="filled"
          label={t('products.eSim.inventory.cells.eSimProfile.disabled')}
          hideIcon
        />
      )}
    </CellLayout>
  );
};
